export enum StreamPlayerModeType {
    LiveStream = "LiveStream",
    Playback = "Playback",
    Diagnostic = "Diagnostic",
}
